import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpWebApiService } from '@sb-shared/services/http-web-api.service';
import { apis, HttpRequestSettings } from '@sb-shared/models/request-settings';
import { UnsubscribeInfo } from '@sb-shared/models/unsubscribe-info';

/**
 * SB-14896: talks to the anonymous, token-only unsubscribe API.
 *
 * No `controllerType` is set, so `HttpWebApiService.formatUrl` targets the
 * non-org-scoped `api/Unsubscribe` endpoints (UnsubscribeController).
 */
@Injectable({
  providedIn: 'root'
})
export class UnsubscribeService {
  private config: HttpRequestSettings = {
    api: apis.Core,
    // UnsubscribeController returns the payload raw (no { data } envelope). Without this the Core
    // default unwraps `res.data`, the page gets undefined and never learns the organisation.
    fullResponse: true,
    showSuccessToast: false // the component drives the UI feedback
  };

  constructor(private http: HttpWebApiService) {}

  getInfo(token: string): Observable<UnsubscribeInfo> {
    return this.http.get('Unsubscribe', { ...this.config, params: { token } });
  }

  unsubscribe(token: string): Observable<UnsubscribeInfo> {
    return this.http.post('Unsubscribe', { token }, this.config);
  }

  resubscribe(token: string): Observable<UnsubscribeInfo> {
    return this.http.post('Unsubscribe/Resubscribe', { token }, this.config);
  }
}
